import { Phone, Mail, MapPin, User } from "lucide-react";
import { CONTACT } from "@/content/site";

const Row = ({ icon: Icon, label, children }) => (
  <li className="flex gap-4">
    <Icon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-gold" />
    <div>
      <p className="font-display text-xs font-semibold uppercase tracking-[0.15em] opacity-70">{label}</p>
      <div className="mt-0.5">{children}</div>
    </div>
  </li>
);

export const ContactDetails = ({ loc, compact = false }) => {
  const a = "inline-flex min-h-[44px] items-center break-words font-semibold underline decoration-gold/60 decoration-1 hover:decoration-gold";
  return (
    <ul className={`mt-4 ${compact ? "space-y-3 text-sm" : "space-y-5"}`} data-testid={`${loc}-contact-details`}>
      <Row icon={User} label="Name"><p className="flex min-h-[44px] items-center font-semibold">{CONTACT.person}</p></Row>
      <Row icon={Phone} label="Phone"><a href={CONTACT.tel} data-loc={loc} className={a} data-testid={`${loc}-phone-link`}>{CONTACT.phone}</a></Row>
      <Row icon={Mail} label="Email"><a href={CONTACT.mailto} data-loc={loc} className={`${a} break-all`} data-testid={`${loc}-email-link`}>{CONTACT.email}</a></Row>
      <Row icon={MapPin} label="Address">
        <a href={CONTACT.map} target="_blank" rel="noopener noreferrer" className={a} data-testid={`${loc}-map-link`}>
          {CONTACT.address}<span className="sr-only"> (opens map in a new tab)</span>
        </a>
      </Row>
    </ul>
  );
};
